// SPDX-License-Identifier: AGPL-3.0-or-later

import type {CompanionSessionStatus} from '@app/features/companion/state/CompanionSessionStore';
import CompanionSessionStore from '@app/features/companion/state/CompanionSessionStore';
import type {GatewayHandlerContext} from '@app/features/gateway/events/EventRouter';

interface CompanionSessionStatePayload {
	session_id: string;
	status: CompanionSessionStatus;
	speakers: Array<string>;
	scene_id?: string;
	error?: string;
	summary?: string;
}

export function handleCompanionSessionState(data: CompanionSessionStatePayload, _context: GatewayHandlerContext): void {
	CompanionSessionStore.handleSessionState(data);
}
